import { h, Component } from "preact";
import { connect } from "react-redux";
import uniq from "lodash/uniq";

import Filter from "./Filter.jsx";
import { setTaskFilter } from "../store/index";
import i18n from "../i18n.js";

@connect(
  (state) => {
    const objectives = uniq(state.tasks.items.map((task) => task.objective));
    return {
      options: [
        { value: "", text: i18n.t("component.task_filter.all") },
        ...uniq(objectives)
          .sort()
          .map((value) => ({
            value,
            text: value,
          })),
      ],
      selected: state.ui.taskFilter,
    };
  },
  { setTaskFilter }
)
export default class TaskFilter extends Component {
  render() {
    // All and only one value, so we don't need that
    if (this.props.options.length === 2) {
      return null;
    }
    return (
      <Filter
        icon="article"
        onChange={this.props.setTaskFilter}
        options={this.props.options}
        selected={this.props.selected}
        dataQa="task-objective-filter"
      />
    );
  }
}
